/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { matchVideoControllerAbortUpload } from '../fn/match-video/match-video-controller-abort-upload';
import { MatchVideoControllerAbortUpload$Params } from '../fn/match-video/match-video-controller-abort-upload';
import { matchVideoControllerAnalyze } from '../fn/match-video/match-video-controller-analyze';
import { MatchVideoControllerAnalyze$Params } from '../fn/match-video/match-video-controller-analyze';
import { matchVideoControllerCancel } from '../fn/match-video/match-video-controller-cancel';
import { MatchVideoControllerCancel$Params } from '../fn/match-video/match-video-controller-cancel';
import { matchVideoControllerCompleteUpload } from '../fn/match-video/match-video-controller-complete-upload';
import { MatchVideoControllerCompleteUpload$Params } from '../fn/match-video/match-video-controller-complete-upload';
import { matchVideoControllerCreateMatchVideo } from '../fn/match-video/match-video-controller-create-match-video';
import { MatchVideoControllerCreateMatchVideo$Params } from '../fn/match-video/match-video-controller-create-match-video';
import { matchVideoControllerDeleteMatchVideo } from '../fn/match-video/match-video-controller-delete-match-video';
import { MatchVideoControllerDeleteMatchVideo$Params } from '../fn/match-video/match-video-controller-delete-match-video';
import { matchVideoControllerGetJob } from '../fn/match-video/match-video-controller-get-job';
import { MatchVideoControllerGetJob$Params } from '../fn/match-video/match-video-controller-get-job';
import { matchVideoControllerGetMatchVideo } from '../fn/match-video/match-video-controller-get-match-video';
import { MatchVideoControllerGetMatchVideo$Params } from '../fn/match-video/match-video-controller-get-match-video';
import { matchVideoControllerGetMatchVideos } from '../fn/match-video/match-video-controller-get-match-videos';
import { MatchVideoControllerGetMatchVideos$Params } from '../fn/match-video/match-video-controller-get-match-videos';
import { matchVideoControllerGetPartUrls } from '../fn/match-video/match-video-controller-get-part-urls';
import { MatchVideoControllerGetPartUrls$Params } from '../fn/match-video/match-video-controller-get-part-urls';
import { matchVideoControllerStartUpload } from '../fn/match-video/match-video-controller-start-upload';
import { MatchVideoControllerStartUpload$Params } from '../fn/match-video/match-video-controller-start-upload';
import { matchVideoControllerUpdateMatchVideo } from '../fn/match-video/match-video-controller-update-match-video';
import { MatchVideoControllerUpdateMatchVideo$Params } from '../fn/match-video/match-video-controller-update-match-video';
import { MatchVideoModelDto } from '../models/match-video-model-dto';
import { PartUrlDto } from '../models/part-url-dto';
import { ProcessingJobModelDto } from '../models/processing-job-model-dto';
import { StartUploadResponseDto } from '../models/start-upload-response-dto';

@Injectable({ providedIn: 'root' })
export class MatchVideoService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `matchVideoControllerGetMatchVideos()` */
  static readonly MatchVideoControllerGetMatchVideosPath = '/match-videos';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matchVideoControllerGetMatchVideos()` instead.
   *
   * This method doesn't expect any request body.
   */
  matchVideoControllerGetMatchVideos$Response(params?: MatchVideoControllerGetMatchVideos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MatchVideoModelDto>>> {
    return matchVideoControllerGetMatchVideos(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `matchVideoControllerGetMatchVideos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  matchVideoControllerGetMatchVideos(params?: MatchVideoControllerGetMatchVideos$Params, context?: HttpContext): Observable<Array<MatchVideoModelDto>> {
    return this.matchVideoControllerGetMatchVideos$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MatchVideoModelDto>>): Array<MatchVideoModelDto> => r.body)
    );
  }

  /** Path part for operation `matchVideoControllerCreateMatchVideo()` */
  static readonly MatchVideoControllerCreateMatchVideoPath = '/match-videos';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matchVideoControllerCreateMatchVideo()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matchVideoControllerCreateMatchVideo$Response(params: MatchVideoControllerCreateMatchVideo$Params, context?: HttpContext): Observable<StrictHttpResponse<MatchVideoModelDto>> {
    return matchVideoControllerCreateMatchVideo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `matchVideoControllerCreateMatchVideo$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matchVideoControllerCreateMatchVideo(params: MatchVideoControllerCreateMatchVideo$Params, context?: HttpContext): Observable<MatchVideoModelDto> {
    return this.matchVideoControllerCreateMatchVideo$Response(params, context).pipe(
      map((r: StrictHttpResponse<MatchVideoModelDto>): MatchVideoModelDto => r.body)
    );
  }

  /** Path part for operation `matchVideoControllerGetMatchVideo()` */
  static readonly MatchVideoControllerGetMatchVideoPath = '/match-videos/{uuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matchVideoControllerGetMatchVideo()` instead.
   *
   * This method doesn't expect any request body.
   */
  matchVideoControllerGetMatchVideo$Response(params: MatchVideoControllerGetMatchVideo$Params, context?: HttpContext): Observable<StrictHttpResponse<MatchVideoModelDto>> {
    return matchVideoControllerGetMatchVideo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `matchVideoControllerGetMatchVideo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  matchVideoControllerGetMatchVideo(params: MatchVideoControllerGetMatchVideo$Params, context?: HttpContext): Observable<MatchVideoModelDto> {
    return this.matchVideoControllerGetMatchVideo$Response(params, context).pipe(
      map((r: StrictHttpResponse<MatchVideoModelDto>): MatchVideoModelDto => r.body)
    );
  }

  /** Path part for operation `matchVideoControllerDeleteMatchVideo()` */
  static readonly MatchVideoControllerDeleteMatchVideoPath = '/match-videos/{uuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matchVideoControllerDeleteMatchVideo()` instead.
   *
   * This method doesn't expect any request body.
   */
  matchVideoControllerDeleteMatchVideo$Response(params: MatchVideoControllerDeleteMatchVideo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return matchVideoControllerDeleteMatchVideo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `matchVideoControllerDeleteMatchVideo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  matchVideoControllerDeleteMatchVideo(params: MatchVideoControllerDeleteMatchVideo$Params, context?: HttpContext): Observable<void> {
    return this.matchVideoControllerDeleteMatchVideo$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `matchVideoControllerUpdateMatchVideo()` */
  static readonly MatchVideoControllerUpdateMatchVideoPath = '/match-videos/{uuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matchVideoControllerUpdateMatchVideo()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matchVideoControllerUpdateMatchVideo$Response(params: MatchVideoControllerUpdateMatchVideo$Params, context?: HttpContext): Observable<StrictHttpResponse<MatchVideoModelDto>> {
    return matchVideoControllerUpdateMatchVideo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `matchVideoControllerUpdateMatchVideo$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matchVideoControllerUpdateMatchVideo(params: MatchVideoControllerUpdateMatchVideo$Params, context?: HttpContext): Observable<MatchVideoModelDto> {
    return this.matchVideoControllerUpdateMatchVideo$Response(params, context).pipe(
      map((r: StrictHttpResponse<MatchVideoModelDto>): MatchVideoModelDto => r.body)
    );
  }

  /** Path part for operation `matchVideoControllerStartUpload()` */
  static readonly MatchVideoControllerStartUploadPath = '/match-videos/{uuid}/upload/start';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matchVideoControllerStartUpload()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matchVideoControllerStartUpload$Response(params: MatchVideoControllerStartUpload$Params, context?: HttpContext): Observable<StrictHttpResponse<StartUploadResponseDto>> {
    return matchVideoControllerStartUpload(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `matchVideoControllerStartUpload$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matchVideoControllerStartUpload(params: MatchVideoControllerStartUpload$Params, context?: HttpContext): Observable<StartUploadResponseDto> {
    return this.matchVideoControllerStartUpload$Response(params, context).pipe(
      map((r: StrictHttpResponse<StartUploadResponseDto>): StartUploadResponseDto => r.body)
    );
  }

  /** Path part for operation `matchVideoControllerGetPartUrls()` */
  static readonly MatchVideoControllerGetPartUrlsPath = '/match-videos/{uuid}/upload/part-urls';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matchVideoControllerGetPartUrls()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matchVideoControllerGetPartUrls$Response(params: MatchVideoControllerGetPartUrls$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PartUrlDto>>> {
    return matchVideoControllerGetPartUrls(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `matchVideoControllerGetPartUrls$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matchVideoControllerGetPartUrls(params: MatchVideoControllerGetPartUrls$Params, context?: HttpContext): Observable<Array<PartUrlDto>> {
    return this.matchVideoControllerGetPartUrls$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PartUrlDto>>): Array<PartUrlDto> => r.body)
    );
  }

  /** Path part for operation `matchVideoControllerCompleteUpload()` */
  static readonly MatchVideoControllerCompleteUploadPath = '/match-videos/{uuid}/upload/complete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matchVideoControllerCompleteUpload()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matchVideoControllerCompleteUpload$Response(params: MatchVideoControllerCompleteUpload$Params, context?: HttpContext): Observable<StrictHttpResponse<MatchVideoModelDto>> {
    return matchVideoControllerCompleteUpload(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `matchVideoControllerCompleteUpload$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matchVideoControllerCompleteUpload(params: MatchVideoControllerCompleteUpload$Params, context?: HttpContext): Observable<MatchVideoModelDto> {
    return this.matchVideoControllerCompleteUpload$Response(params, context).pipe(
      map((r: StrictHttpResponse<MatchVideoModelDto>): MatchVideoModelDto => r.body)
    );
  }

  /** Path part for operation `matchVideoControllerAbortUpload()` */
  static readonly MatchVideoControllerAbortUploadPath = '/match-videos/{uuid}/upload/abort';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matchVideoControllerAbortUpload()` instead.
   *
   * This method doesn't expect any request body.
   */
  matchVideoControllerAbortUpload$Response(params: MatchVideoControllerAbortUpload$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return matchVideoControllerAbortUpload(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `matchVideoControllerAbortUpload$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  matchVideoControllerAbortUpload(params: MatchVideoControllerAbortUpload$Params, context?: HttpContext): Observable<void> {
    return this.matchVideoControllerAbortUpload$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `matchVideoControllerAnalyze()` */
  static readonly MatchVideoControllerAnalyzePath = '/match-videos/{uuid}/analyze';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matchVideoControllerAnalyze()` instead.
   *
   * This method doesn't expect any request body.
   */
  matchVideoControllerAnalyze$Response(params: MatchVideoControllerAnalyze$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessingJobModelDto>> {
    return matchVideoControllerAnalyze(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `matchVideoControllerAnalyze$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  matchVideoControllerAnalyze(params: MatchVideoControllerAnalyze$Params, context?: HttpContext): Observable<ProcessingJobModelDto> {
    return this.matchVideoControllerAnalyze$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProcessingJobModelDto>): ProcessingJobModelDto => r.body)
    );
  }

  /** Path part for operation `matchVideoControllerGetJob()` */
  static readonly MatchVideoControllerGetJobPath = '/match-videos/{uuid}/job';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matchVideoControllerGetJob()` instead.
   *
   * This method doesn't expect any request body.
   */
  matchVideoControllerGetJob$Response(params: MatchVideoControllerGetJob$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessingJobModelDto>> {
    return matchVideoControllerGetJob(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `matchVideoControllerGetJob$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  matchVideoControllerGetJob(params: MatchVideoControllerGetJob$Params, context?: HttpContext): Observable<ProcessingJobModelDto> {
    return this.matchVideoControllerGetJob$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProcessingJobModelDto>): ProcessingJobModelDto => r.body)
    );
  }

  /** Path part for operation `matchVideoControllerCancel()` */
  static readonly MatchVideoControllerCancelPath = '/match-videos/{uuid}/cancel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matchVideoControllerCancel()` instead.
   *
   * This method doesn't expect any request body.
   */
  matchVideoControllerCancel$Response(params: MatchVideoControllerCancel$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessingJobModelDto>> {
    return matchVideoControllerCancel(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `matchVideoControllerCancel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  matchVideoControllerCancel(params: MatchVideoControllerCancel$Params, context?: HttpContext): Observable<ProcessingJobModelDto> {
    return this.matchVideoControllerCancel$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProcessingJobModelDto>): ProcessingJobModelDto => r.body)
    );
  }

}
